<div
  class="flex flex-col bg-no-repeat bg-cover bg-center px-2 py-2 md:py-4 md:px-8 lg:px-12 lg:py-4"
  style="background-image: url('/assets/images/body.webp');">
  <div class="w-full flex justify-center mb-4 mt-8 md:mt-12 lg:mt-0 order-2 lg:order-1">
    <app-top-navbar class="w-full max-w-8xl"></app-top-navbar>
  </div>

  <div class="w-full flex justify-center mb-6 order-1 lg:order-2">
    <app-navbar class="w-full max-w-8xl"></app-navbar>
  </div>
  <div class="w-full max-w-6xl mx-auto order-3 flex flex-col gap-2">
    @if (getOrderTypeLabel() && getFormattedLocation().text) {
    <div class="flex items-center justify-center h-auto">
      <div class="address-pill">
        <div class="type-section">
          <p class="type-text"
          [class.text-primary]="isMilano" [class.text-base]="!isMilano">{{ getOrderTypeLabel() }}</p>
            @if (isDelivery) {
    <p class="delay-text">Délai : {{ formatDeliveryDelay() }}</p>
    }
    </div>
    <div class="location-section"
    [class.bg-primary]="isMilano" [class.bg-secondary/20]="!isMilano">
      <div class="location-info">
        <p class="location-address">{{ getFormattedLocation().text }}</p>
              @if (getMinOrderAmount()) {
    <p class="min-amount">{{ getMinOrderAmount() }}</p>
    }
    </div>
    <button (click)="openDialog()" class="edit-action">
      <mat-icon>edit</mat-icon>
    </button>
  </div>
</div>
</div>
    }
    <span class="font-normal text-[18px] text-center md:text-[28px] text-[#FFFFFF] text">Commandez vos plats préférés en quelques clics ! 😋</span>

  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<!-- Helper ng-template: reusable price block (original + discounted)          -->
<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<ng-template #priceBlock let-basePrice="basePrice">
  @if (discountReduction && !isRedeemMode) {
  <!-- Original price barré -->
  <span class="text-sm line-through text-gray-400 font-normal">
  {{ truncate2(basePrice) | number:'1.2-2' }} {{ product.currency }}
  </span>
  <!-- Prix remisé -->
  <span class="font-bold text-[#EB3D08] flex items-center gap-1">
  {{ applyReduction(basePrice, discountReduction) | number:'1.2-2' }} {{ product.currency }}
  @if (formatReduction(discountReduction)) {
  <span class="text-xs bg-[#EB3D08] text-white px-1.5 py-0.5 rounded-full"
  >
          {{ formatReduction(discountReduction) }}
        </span>
  }
  </span>
  } @else {
  <span class="font-bold">
  {{ truncate2(basePrice) | number:'1.2-2' }} {{ product.currency }}
  </span>
  }
</ng-template>

<div class="">
  @if (isLoading()) {
  <div class="flex justify-center items-center min-h-[400px]">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-secondary"></div>
    <span class="ml-2 text-gray-600">Chargement en cours...</span>
  </div>
  }

  @if (product && !isLoading()) {
  <div class="py-4 px-4 md:px-8 lg:px-12">
    <!-- ═══════════════════════════════════════════════════════════════════ -->
    <!-- MOBILE                                                             -->
    <!-- ═══════════════════════════════════════════════════════════════════ -->
    <div class="md:hidden space-y-6">
      <div class=" content-card bg-base-200 rounded-lg p-4 ">
        <div class="flex items-center gap-2">
          <div class="relative w-[40%] aspect-square">
  <img
    [ngSrc]="product.image || 'assets/images/placeholders/placeholder.webp'"
    [alt]="product.name || 'Image à venir'"
    fill
    loading="lazy"
    sizes="40vw"
    class="rounded-lg object-contain" />
</div>
            <div class="">
              <div>
                <h1 class="text-primary text-xl font-semibold mb-2">{{product.name}}
  @if (selectedSize) {
  <span class="text-[15px] font-normal text-site">({{selectedSize}})</span>
  }
  </h1>
</div>
<div class="mb-2">
  @if (product.pricePerSizes.length === 0) {
  @if (discountReduction && !isRedeemMode) {
  <p
  class="text-sm line-through text-site">{{ formatBasePrice(product.price) }}</p>
                      <p class="text-lg font-bold text-red-500 flex items-center gap-1">
  {{ formatBasePrice(applyReduction(product.price, discountReduction)) }}
  @if (formatReduction(discountReduction)) {
  <span
    class="text-xs bg-[#EB3D08] text-white px-1.5 py-0.5 rounded-full"
  >{{ formatReduction(discountReduction) }}</span>
  }
  </p>
  } @else {
  <p
  class="text-lg font-bold mb-2">{{ formatBasePrice(product.price) }}</p>
  }
  }
  @if (product.pricePerSizes.length > 0) {
  @if (discountReduction && !isRedeemMode) {
  <p
  class="text-sm line-through text-site">{{ formatBasePrice(selectedPrice) }}</p>
                      <p class="text-lg font-bold text-red-500 flex items-center gap-1">
  {{ applyReduction(selectedPrice, discountReduction) | number:'1.2-2' }} {{ product.currency }}
  @if (formatReduction(discountReduction)) {
  <span
    class="text-xs bg-[#EB3D08] text-white px-1.5 py-0.5 rounded-full"
  >{{ formatReduction(discountReduction) }}</span>
  }
  </p>
  } @else {
  <p
  class="text-lg font-bold mb-2 text-site">{{ formatBasePrice(selectedPrice) }}</p>
  }
  }
  </div>
</div>
</div>
<!-- Prix mobile -->
<p class="text-site text-sm text-center">{{product.description}}</p>
          </div>
          <div class="space-y-6">
            @if (product.ingredients.length > 0) {
  <div class="flex flex-col gap-3">
    <h2 class="title text-secondary text-[24px]">Composition: Décochez si un ingrédient ne vous convient pas 😋🤤</h2>
    <div class="grid 2xl:grid-cols-2 gap-3">
      @for (ingredient of product.ingredients; track ingredient) {
      <label class="ingredient-card bg-base-200 border-border flex items-center justify-between p-3 rounded-lg border"
       [class.cursor-not-allowed]="ingredient.required">

  <div class="flex items-center space-x-3 flex-1 min-w-0">
    <mat-checkbox
      [checked]="selectedIngredients.includes(ingredient.id)"
      [disabled]="ingredient.required"
      (change)="onIngredientChange($event, ingredient.id)">
    </mat-checkbox>

    <div class="flex-1 min-w-0 flex items-center flex-wrap gap-2">
      <span class="text-base text-site font-medium">{{ ingredient.name }}</span>
      @if (ingredient.required) {
      <span class="bg-[#15803D] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] whitespace-nowrap">
          Obligatoire
        </span>
      }
      </div>
    </div>

    @if (ingredient.image) {
      <img [ngSrc]="ingredient.image || 'assets/images/placeholders/placeholder.webp'"
           [alt]="ingredient.name || 'Image à venir'"
           width="60" height="60" loading="lazy"
           class="ingredient-img rounded-lg object-cover">
      }
      </label>
      }
    </div>
  </div>
  }
  @if (product.additions.length >0 && filteredAdditions.length>0) {
  <h2 class="text-[24px] text-[#FF730A] title mb-0 sticky top-0 z-10"
  >
    Choisissez vos accompagnements 🍗🥦🧀️🥣🥤
  </h2>
  }
  @for (addition of filteredAdditions; track addition; let i = $index) {
  <div class="addition-block"
       [attr.id]="'mobile-component-' + i">
    <h3 class="text-[24px] text-[#FF730A] title mb-3 sticky top-0 z-10">
      {{ getAdditionTitle(addition) }}
      <span class="text-[18px] font-normal text-gray-600">
                    ({{ addition.required ? 'Obligatoire' : 'Optionnel' }} - {{ getTotalQuantityForAddition(addition.id) }}
        /{{ addition.quantity }} choix)
                  </span>
    </h3>
    <div class="grid 2xl:grid-cols-2 gap-3">
      @for (item of addition.items; track item) {
      <div
        class="relative flex items-center justify-between px-[14px] bg-base-200  border cursor-pointer label rounded-[6px]"
        [class.border-orange-500]="getItemQuantity(addition.id, item.id) > 0"
        [class.bg-orange-50]="getItemQuantity(addition.id, item.id) > 0"
        [class.opacity-60]="item.available === false"
        [class.cursor-not-allowed]="item.available === false"
        [class.cursor-pointer]="item.available === true">
        @if (item.available === false) {
      <span
        class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                          Non disponible
                        </span>
      }
      <div class="flex items-center space-x-3 flex-1 min-w-0">
        <div class="flex-1 min-w-0">
          <span class="text-base text-site font-medium break-words">{{ item.name }}</span>
                          @if (item.price) {
      <span class="text-sm text-site ml-2">(+{{item.price}} {{item.currency}})</span>
      }
      </div>
    </div>
    <div class="flex items-center gap-2 flex-shrink-0 mr-3">
      <button (click)="decrementItem(addition.id, item.id)"
        [disabled]="getItemQuantity(addition.id, item.id) === 0"
        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
        -
      </button>
      <span class="font-bold min-w-[20px] text-center">{{ getItemQuantity(addition.id, item.id) }}</span>
                        <button
                          [disabled]="item.available === false"
                          (click)="incrementItem(addition.id, item.id, addition.quantity, i)"
                          class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
                          +
                        </button>
                      </div>
                      @if (item.image) {
      <img
        [ngSrc]="item.image || 'assets/images/placeholders/placeholder.webp'"
        [alt]="item.name || 'Image à venir'"
        width="64"
        height="64"
        loading="lazy"
        class="w-16 h-16 rounded-lg flex-shrink-0">
      }
      </div>
      }
    </div>
  </div>
  }
  @if (product.supplements.length > 0) {
  <h2 class="text-[24px] text-[#FF730A] title mb-0 sticky top-0 z-10"
  >
    Ingrédients Supplémentaires 🍟🧀️🍗
  </h2>
  }
  @for (category of getSupplementCategories(); track category) {
  <div class="flex flex-col gap-3">
    <h3 class="text-[24px] text-[#FF730A] title mb-3 sticky top-0 z-10">{{ category }}</h3>
    <div class="grid 2xl:grid-cols-2 gap-3">
      @for (supplement of supplementsByCategory[category]; track supplement) {
      <label
        class="flex items-center justify-between px-[14px] bg-base-200  border cursor-pointer label rounded-[6px]"
        [class.border-orange-500]="isSupplementSelected(supplement.id)"
        [class.bg-orange-50]="isSupplementSelected(supplement.id)">
        <div class="flex items-center space-x-3 flex-1 min-w-0">
          <mat-checkbox [checked]="isSupplementSelected(supplement.id)"
          (click)="$event.stopPropagation();toggleSupplement(supplement.id)"></mat-checkbox>
          <div class="flex-1 min-w-0">
            <span class="text-base text-site font-medium break-words">{{ supplement.name }}</span>
                          <span
                            class="text-sm text-site ml-2">(+{{ truncate2(getSupplementPrice(supplement)) | number:'1.2-2' }} {{ supplement.currency }}
      )</span>
    </div>
  </div>
  @if (supplement.image) {
      <img
        [ngSrc]="supplement.image || 'assets/images/placeholders/placeholder.webp'"
        [alt]="supplement.name || 'Image à venir'"
        width="64"
        height="64"
        loading="lazy"
        class="w-16 h-16 rounded-lg flex-shrink-0">
      }
      </label>
      }
    </div>
  </div>
  }
  </div>
  <!-- Mobile bottom bar -->
  <div
    class="fixed bottom-0 left-0 right-0 bg-[#2B150575] backdrop-blur-md border-b border-orange-900/30 border-t mx-[16px] shadow-lg p-2 z-50">
    @if (!canAddToCart()) {
  <p
    class="text-[#FF730A] text-xs text-center mb-1 font-medium">
    {{ getValidationMessage() }}
  </p>
  }
  <div class="flex items-center justify-center">
    <button (click)="toggleCartSheet()"
      [disabled]="!canAddToCart()"
      [class.disabled]="!canAddToCart()"
      class="add bg-[#FF730A] text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 w-full justify-center">
      <span class="text-[15px]">Voir détails</span>
      <span class="text-[14px]">({{ formatTotal() }})</span>
              </button>
            </div>
          </div>
          <!-- Mobile cart sheet -->
          @if (isCartSheetOpen) {
  <div class="fixed inset-0 z-[60]" (click)="toggleCartSheet()">
    <div class="absolute inset-0 bg-neutral transition-opacity duration-300"
         [class.opacity-50]="isCartSheetOpen" [class.opacity-0]="!isCartSheetOpen"></div>
    <div (click)="$event.stopPropagation()"
         (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()"
         class="absolute bottom-0 left-0 right-0 bg-base-200 rounded-t-2xl shadow-2xl max-h-[85vh] flex flex-col"
         [style.transform]="sheetTransform">
      <div class="flex justify-center pt-3">
        <div class="w-12 h-1 bg-gray-300 rounded-full" (click)="toggleCartSheet()"></div>
      </div>
      <div class="flex justify-end pr-3">
        <mat-icon class="text-gray-300 cursor-pointer" (click)="toggleCartSheet()">close</mat-icon>
      </div>
      <div class="flex-1 overflow-y-auto px-4 py-2 space-y-4" #scrollableContent>
        <div class=" rounded-[6px] p-[12px]">
          <div class="flex justify-between items-start mb-2">
            <div class="flex-1">
              <p class="font-semibold text-site title text-primary">{{product.name}}</p>
              @if (selectedSize) {
              <span class="text-[15px] font-normal text-dark opacity-60">({{selectedSize}}
              )</span>
              }
            </div>
            <div class="text-right">
              @if (discountReduction && !isRedeemMode) {
              <p class="text-xs line-through text-dark opacity-40">
              {{ formatBasePrice(product.pricePerSizes.length === 0 ? product.price : selectedPrice) }}
              </p>
              <p class="font-bold text-dark text-lg flex items-center gap-1 justify-end">
              {{ formatBasePrice(discountedBasePrice) }}
              @if (formatReduction(discountReduction)) {
              <span class="text-xs bg-[#EB3D08] text-white px-1 py-0.5 rounded-full"
              >
                                {{ formatReduction(discountReduction) }}
                              </span>
              }
              </p>
              }
              @if (!discountReduction || isRedeemMode) {
              <p class="font-bold text-dark text-lg">
              {{ formatBasePrice(product.pricePerSizes.length === 0 ? product.price : selectedPrice) }}              </p>
              }
            </div>
          </div>
          <div class="mb-4">
            @if (selectedIngredients.length) {
            <div class=" p-[12px] mt-2">
              <span class="text-sm text-dark font-semibold block mb-2 tracking-wider">Composition</span>
              @for (ingredient of product.ingredients; track ingredient) {
            <div>
              <div class="text-sm flex ml-2"
                   [ngClass]="{
                                       'opacity-80 text-dark': selectedIngredients.includes(ingredient.id),
                                       'line-through text-red-500': excludedIngredients.includes(ingredient.id)
                                     }">
                <span>- {{ ingredient.name }}</span>
              </div>
            </div>
            }
            </div>
            }
            @if (hasSelectedAdditions()) {
            <div class=" p-[12px] mt-2">
              @for (addition of filteredAdditions; track addition) {
            <div>
              @if (getTotalQuantityForAddition(addition.id) > 0) {
              <span class="text-sm text-dark font-semibold block mb-2 tracking-wider">
              {{ getAdditionTitle(addition) }}
              @if (addition.itemsSize) {
              <span class="text-sm text-dark opacity-60"
              >(Taille {{addition.itemsSize.name}})</span>
              }
              </span>
              @for (item of addition.items; track item) {
              <div>
                @if (getItemQuantity(addition.id, item.id) > 0) {
                <div
                  class="text-sm text-dark flex justify-between items-center mb-1">
                  <span>+ {{ item.name }} <span
                                        class="text-xs opacity-60">x{{ getItemQuantity(addition.id, item.id) }}</span></span>
                                        @if (item.price) {
                <span
                  class="font-medium">{{ truncate2(item.price * getItemQuantity(addition.id, item.id)) | number:'1.2-2' }} {{ item.currency }}</span>
                }
                </div>
                }
              </div>
              }
              }
            </div>
            }
            </div>
            }
            @if (Object.keys(selectedSupplements).length > 0) {
            <div class=" p-[12px] mt-2">
              <span class="text-sm text-dark font-semibold block mb-1">Suppléments</span>
              @for (supplementId of Object.keys(selectedSupplements); track supplementId) {
            <div>
              @for (supplement of product.supplements; track supplement) {
              @if (supplement.id === supplementId) {
              <div
                class="text-sm ext-black flex justify-between items-center mb-1 ml-2">
                                    <span>
                                      @if (supplement.categories?.length > 0) {
                                      <span class="font-bold text-dark">
                                          {{ supplement.categories[0] }}
                                        </span>
                                      }
                                      @if (supplement.categories?.length > 0) {
                                      <span> - </span>
                                      }
                                      {{ supplement.name }}
                                      <span
                                        class="text-green-600 font-normal">(+{{ truncate2(getSupplementPrice(supplement)) | number:'1.2-2' }} {{ supplement.currency }}
                                        )</span>
                                    </span>
                <mat-icon class="material-symbols-outlined cursor-pointer"
                          style="color: red; opacity: 0.7;"
                          (click)="toggleSupplement(supplementId)">delete
                </mat-icon>
              </div>
              }
              }
            </div>
            }
            </div>
            }
          </div>
        </div>
      </div>
      <div class="border-t border-gray-200 p-4 bg-base-200 flex flex-col gap-3">
        <div class="flex items-center justify-between">
          <span class="font-semibold text-dark">Quantité</span>
          <div class="flex items-center space-x-3">
            <button (click)="decrementProductQuantity()" [disabled]="productQuantity <= 1"
                    class="w-9 h-9 rounded-full border-2 border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50">
              <span class="text-xl font-bold">-</span>
            </button>
            <span class="font-bold text-xl w-12 text-center">{{ productQuantity }}</span>
            <button (click)="incrementProductQuantity()"
                    class="w-9 h-9 rounded-full border-2 border-gray-300 flex items-center justify-center hover:bg-gray-100">
              <span class="text-xl font-bold">+</span>
            </button>
          </div>
        </div>
        <div class="flex justify-between items-center text-xl font-bold pt-3 border-t border-gray-200">
          <span class="text-dark">Total</span>
          <span
            class="text-dark">{{ formatTotal() }}</span>
        </div>
        <button (click)="addToCart()"
                [matButton]="themeConfig.appearance.button.action"
                class="w-full py-2 "
                [disabled]="!canAddToCart() || isSubmitting()"

        >
          Ajouter au panier
        </button>
        @if (!canAddToCart()) {
        <p class="text-red-500 text-sm text-center">{{ getValidationMessage() }}</p>
        }
      </div>
    </div>
  </div>
  }
  </div>
  <!-- ═══════════════════════════════════════════════════════════════════ -->
  <!-- TABLET                                                             -->
  <!-- ═══════════════════════════════════════════════════════════════════ -->
  <div class="hidden md:flex xl:hidden gap-4">
    <div class="w-1/3 flex-shrink-0">
      <div class="sticky top-4">
        <div class="flex items-center justify-center mb-4">
          <div class="relative w-full aspect-square">
  <img
    [ngSrc]="product.image || 'assets/images/placeholders/placeholder.webp'"
    [alt]="product.name || 'Image à venir'"
    fill
    loading="lazy"
    sizes="33vw"
    class="rounded-lg object-contain label bg-base-200" />
</div>
          </div>
          <h1 class="text-primary text-2xl font-semibold mb-2">{{product.name}}
  @if (selectedSize) {
  <span class="text-[15px] font-normal text-site">({{selectedSize}})</span>
  }
  </h1>
  <!-- Prix tablet -->
  <div class="mb-2">
    @if (product.pricePerSizes.length === 0) {
  @if (discountReduction && !isRedeemMode) {
  <p
  class="text-sm line-through text-site">{{ formatBasePrice(product.price) }}</p>
                      <p class="text-xl font-bold text-site flex items-center gap-1">
  {{ formatBasePrice(applyReduction(product.price, discountReduction)) }}
  @if (formatReduction(discountReduction)) {
  <span
    class="text-xs bg-[#EB3D08] text-white px-1.5 py-0.5 rounded-full"
  >{{ formatReduction(discountReduction) }}</span>
  }
  </p>
  } @else {
  <p
  class="text-xl font-bold mb-2 text-site">{{ formatBasePrice(product.price) }}</p>
  }
  }
  @if (product.pricePerSizes.length > 0) {
  @if (discountReduction && !isRedeemMode) {
  <p
  class="text-sm line-through text-site">{{ formatBasePrice(selectedPrice) }}</p>
                      <p class="text-xl font-bold text-red-500 flex items-center gap-1">
  {{ applyReduction(selectedPrice, discountReduction) | number:'1.2-2' }} {{ product.currency }}
  @if (formatReduction(discountReduction)) {
  <span
    class="text-xs bg-[#EB3D08] text-white px-1.5 py-0.5 rounded-full"
  >{{ formatReduction(discountReduction) }}</span>
  }
  </p>
  } @else {
  <p
  class="text-xl font-bold mb-2 text-site">{{ formatBasePrice(selectedPrice) }}</p>
  }
  }
  </div>
  <p class="text-site text-sm leading-relaxed">{{product.description}}</p>
              </div>
            </div>
            <div class="flex-1 overflow-y-auto pr-4">
              <div class="space-y-6">
                @if (product.ingredients.length > 0) {
  <div class="flex flex-col gap-3">
    <h2 class="title text-secondary text-[24px]">Composition: Décochez si un ingrédient ne vous convient pas 😋🤤</h2>
    <div class="grid 2xl:grid-cols-2 gap-3">
      @for (ingredient of product.ingredients; track ingredient) {
      <label class="ingredient-card bg-base-200 border-border flex items-center justify-between p-3 rounded-lg border"
       [class.cursor-not-allowed]="ingredient.required">

  <div class="flex items-center space-x-3 flex-1 min-w-0">
    <mat-checkbox
      [checked]="selectedIngredients.includes(ingredient.id)"
      [disabled]="ingredient.required"
      (change)="onIngredientChange($event, ingredient.id)">
    </mat-checkbox>

    <div class="flex-1 min-w-0 flex items-center flex-wrap gap-2">
      <span class="text-base text-site font-medium">{{ ingredient.name }}</span>
      @if (ingredient.required) {
      <span class="bg-[#15803D] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] whitespace-nowrap">
          Obligatoire
        </span>
      }
      </div>
    </div>

    @if (ingredient.image) {
      <img [ngSrc]="ingredient.image || 'assets/images/placeholders/placeholder.webp'"
           [alt]="ingredient.name || 'Image à venir'"
           width="60" height="60" loading="lazy"
           class="ingredient-img rounded-lg object-cover">
      }
      </label>
      }
    </div>
  </div>
  }
  @if (product.additions.length >0 && filteredAdditions.length>0) {
  <h2 class="text-[24px] text-[#FF730A] title mb-0 sticky top-0 z-10"
  >
    Choisissez vos accompagnements 🍗🥦🧀️🥣🥤
  </h2>
  }
  @for (addition of filteredAdditions; track addition; let i = $index) {
  <div class="addition-block"
       [attr.id]="'tablet-component-' + i">
    <h3 class="text-[24px] text-[#FF730A] title mb-3 sticky top-0 z-10">
      {{ getAdditionTitle(addition) }}
      <span class="text-[18px] font-normal text-gray-600">
                        ({{ addition.required ? 'Obligatoire' : 'Optionnel' }} - {{ getTotalQuantityForAddition(addition.id) }}
        /{{ addition.quantity }} choix)
                      </span>
    </h3>
    <div class="grid 2xl:grid-cols-2 gap-3">
      @for (item of addition.items; track item) {
      <div
        class="relative flex items-center justify-between px-[14px] bg-base-200  border cursor-pointer label rounded-[6px]"
        [class.border-orange-500]="getItemQuantity(addition.id, item.id) > 0"
        [class.bg-orange-50]="getItemQuantity(addition.id, item.id) > 0"
        [class.opacity-60]="item.available === false"
        [class.cursor-not-allowed]="item.available === false"
        [class.cursor-pointer]="item.available === true">
        @if (item.available === false) {
      <span
        class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                              Non disponible
                            </span>
      }
      <div class="flex items-center space-x-3 flex-1 min-w-0">
        <div class="flex-1 min-w-0">
          <span class="text-base text-site font-medium break-words">{{ item.name }}</span>
                              @if (item.price) {
      <span class="text-sm text-site ml-2">(+{{item.price}} {{item.currency}}
        )</span>
      }
      </div>
    </div>
    <div class="flex items-center gap-2 flex-shrink-0 mr-3">
      <button (click)="decrementItem(addition.id, item.id)"
        [disabled]="getItemQuantity(addition.id, item.id) === 0"
        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
        -
      </button>
      <span class="font-bold min-w-[20px] text-center">{{ getItemQuantity(addition.id, item.id) }}</span>
                            <button [disabled]="item.available === false"
                              (click)="incrementItem(addition.id, item.id, addition.quantity, i)"
                              class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
                              +
                            </button>
                          </div>
                          @if (item.image) {
      <img
        [ngSrc]="item.image || 'assets/images/placeholders/placeholder.webp'"
        [alt]="item.name || 'Image à venir'"
        width="64"
        height="64"
        loading="lazy"
        class="w-16 h-16 rounded-lg flex-shrink-0">
      }
      </div>
      }
    </div>
  </div>
  }
  @if (product.supplements.length > 0) {
  <h2 class="text-[24px] text-[#FF730A] title mb-0 sticky top-0 z-10"
  >Ingrédients Supplémentaires 🍟🧀️🍗</h2>
  }
  @for (category of getSupplementCategories(); track category) {
  <div class="flex flex-col gap-3">
    <h3 class="text-[24px] text-[#FF730A] title mb-3 sticky top-0 z-10">{{ category }}</h3>
    <div class="grid 2xl:grid-cols-2 gap-3">
      @for (supplement of supplementsByCategory[category]; track supplement) {
      <label
        class="flex items-center justify-between px-[14px] bg-base-200  border cursor-pointer label rounded-[6px]"
        [class.border-orange-500]="isSupplementSelected(supplement.id)"
        [class.bg-orange-50]="isSupplementSelected(supplement.id)">
        <div class="flex items-center space-x-3 flex-1 min-w-0">
          <mat-checkbox [checked]="isSupplementSelected(supplement.id)"
          (click)="$event.stopPropagation();toggleSupplement(supplement.id)"></mat-checkbox>
          <div class="flex-1 min-w-0">
            <span class="text-base text-site font-medium break-words">{{ supplement.name }}</span>
                              <span
                                class="text-sm text-site ml-2">(+{{ truncate2(getSupplementPrice(supplement)) | number:'1.2-2' }} {{ supplement.currency }}
      )</span>
    </div>
  </div>
  @if (supplement.image) {
      <img
        [ngSrc]="supplement.image || 'assets/images/placeholders/placeholder.webp'"
        [alt]="supplement.name || 'Image à venir'"
        width="64"
        height="64"
        loading="lazy"
        class="w-16 h-16 rounded-lg flex-shrink-0">
      }
      </label>
      }
    </div>
  </div>
  }
  </div>
</div>
<!-- Tablet bottom bar (same as mobile) -->
<div
  class="fixed bottom-0 left-0 right-0 bg-[#2B150575] backdrop-blur-md border-b border-orange-900/30 border-t shadow-lg p-4 z-50 mx-[32px]">
  @if (!canAddToCart()) {
  <p
    class="text-[#FF730A] text-xs text-center mb-1 font-medium">
    {{ getValidationMessage() }}
  </p>
  }
  <div class="flex items-center justify-center">
    <button [disabled]="!canAddToCart()"
      (click)="toggleCartSheet()"
      [class.disabled]="!canAddToCart()"
      class="add bg-[#FF730A] text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 w-full justify-center">
<span>Voir détails</span>
<span>({{ formatTotal() }})</span>
          </button>
        </div>
      </div>
      <!-- Tablet cart sheet (same structure as mobile) -->
      @if (isCartSheetOpen) {
  <div class="fixed inset-0 z-[60]" (click)="toggleCartSheet()">
    <div class="absolute inset-0 bg-neutral transition-opacity duration-300"
         [class.opacity-50]="isCartSheetOpen" [class.opacity-0]="!isCartSheetOpen"></div>
    <div (click)="$event.stopPropagation()"
         (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()"
         class="absolute bottom-0 left-0 right-0 bg-base-200 rounded-t-2xl shadow-2xl max-h-[85vh] flex flex-col"
         [style.transform]="sheetTransform">
      <div class="flex justify-center pt-3">
        <div class="w-12 h-1 bg-gray-300 rounded-full" (click)="toggleCartSheet()"></div>
      </div>
      <div class="flex justify-end pr-3">
        <mat-icon class="text-gray-300 cursor-pointer" (click)="toggleCartSheet()">close</mat-icon>
      </div>
      <div class="flex-1 overflow-y-auto px-4 py-2 space-y-4" #scrollableContent>
        <div class=" rounded-[6px] p-[12px]">
          <div class="flex justify-between items-start mb-2">
            <div class="flex-1">
              <p class="font-semibold text-site title text-primary">{{product.name}}</p>
              @if (selectedSize) {
              <span class="text-[15px] font-normal text-dark opacity-60">({{selectedSize}}
              )</span>
              }
            </div>
            <div class="text-right">
              @if (discountReduction && !isRedeemMode) {
              <p class="text-xs line-through text-dark opacity-40">
              {{ formatBasePrice(product.pricePerSizes.length === 0 ? product.price : selectedPrice) }}
              </p>
              <p class="font-bold text-dark text-lg flex items-center gap-1 justify-end">
              {{ formatBasePrice(discountedBasePrice) }}
              @if (formatReduction(discountReduction)) {
              <span class="text-xs bg-[#EB3D08] text-white px-1 py-0.5 rounded-full"
              >
                            {{ formatReduction(discountReduction) }}
                          </span>
              }
              </p>
              }
              @if (!discountReduction || isRedeemMode) {
              <p class="font-bold text-dark text-lg">
              {{ formatBasePrice(product.pricePerSizes.length === 0 ? product.price : selectedPrice) }}
              </p>
              }
            </div>
          </div>
          <div class="mb-4">
            @if (selectedIngredients.length) {
            <div class=" p-[12px] mt-2">
              <span class="text-sm text-dark font-semibold block mb-2 tracking-wider">Composition</span>
              @for (ingredient of product.ingredients; track ingredient) {
            <div>
              <div class="text-sm flex ml-2"
                   [ngClass]="{
                                       'opacity-80 text-dark': selectedIngredients.includes(ingredient.id),
                                       'line-through text-red-500': excludedIngredients.includes(ingredient.id)
                                     }">
                <span>- {{ ingredient.name }}</span>
              </div>
            </div>
            }
            </div>
            }
            @if (hasSelectedAdditions()) {
            <div class=" p-[12px] mt-2">
              @for (addition of filteredAdditions; track addition) {
            <div>
              @if (getTotalQuantityForAddition(addition.id) > 0) {
              <span class="text-sm text-dark font-semibold block mb-2 tracking-wider">
              {{ getAdditionTitle(addition) }}
              @if (addition.itemsSize) {
              <span class="text-sm text-dark opacity-60"
              >(Taille {{addition.itemsSize.name}})</span>
              }
              </span>
              @for (item of addition.items; track item) {
              <div>
                @if (getItemQuantity(addition.id, item.id) > 0) {
                <div
                  class="text-sm text-dark flex justify-between items-center mb-1">
                  <span>+ {{ item.name }} <span
                                    class="text-xs opacity-60">x{{ getItemQuantity(addition.id, item.id) }}</span></span>
                                    @if (item.price) {
                <span
                  class="font-medium">{{ truncate2(item.price * getItemQuantity(addition.id, item.id)) | number:'1.2-2' }} {{ item.currency }}</span>
                }
                </div>
                }
              </div>
              }
              }
            </div>
            }
            </div>
            }
            @if (Object.keys(selectedSupplements).length > 0) {
            <div class=" p-[12px] mt-2">
              <span class="text-sm text-dark font-semibold block mb-1">Suppléments</span>
              @for (supplementId of Object.keys(selectedSupplements); track supplementId) {
            <div>
              @for (supplement of product.supplements; track supplement) {
              @if (supplement.id === supplementId) {
              <div
                class="text-sm ext-black flex justify-between items-center mb-1 ml-2">
                                <span>
                                  @if (supplement.categories?.length > 0) {
                                  <span class="font-bold text-dark">
                                      {{ supplement.categories[0] }}
                                    </span>
                                  }
                                  @if (supplement.categories?.length > 0) {
                                  <span> - </span>
                                  }
                                  {{ supplement.name }}
                                  <span
                                    class="text-green-600 font-normal">(+{{ truncate2(getSupplementPrice(supplement)) | number:'1.2-2' }} {{ supplement.currency }}
                                    )</span>
                                </span>
                <mat-icon class="material-symbols-outlined cursor-pointer"
                          style="color: red; opacity: 0.7;"
                          (click)="toggleSupplement(supplementId)">delete
                </mat-icon>
              </div>
              }
              }
            </div>
            }
            </div>
            }
          </div>
        </div>
      </div>
      <div class="border-t border-gray-200 p-4 bg-base-200 flex flex-col gap-3">
        <div class="flex items-center justify-between">
          <span class="font-semibold text-dark">Quantité</span>
          <div class="flex items-center space-x-3">
            <button (click)="decrementProductQuantity()" [disabled]="productQuantity <= 1"
                    class="w-9 h-9 rounded-full border-2 border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50">
              <span class="text-xl font-bold">-</span>
            </button>
            <span class="font-bold text-xl w-12 text-center">{{ productQuantity }}</span>
            <button (click)="incrementProductQuantity()"
                    class="w-9 h-9 rounded-full border-2 border-gray-300 flex items-center justify-center hover:bg-gray-100">
              <span class="text-xl font-bold">+</span>
            </button>
          </div>
        </div>
        <div class="flex justify-between items-center text-xl font-bold pt-3 border-t border-gray-200">
          <span class="text-dark">Total</span>
          <span
            class="text-dark">{{ formatTotal()  }}</span>
        </div>
        <button
          [matButton]="themeConfig.appearance.button.action"
          [disabled]="!canAddToCart() || isSubmitting()"
          class="w-full py-2 " (click)="addToCart()"

        >
          Ajouter au panier
        </button>
        @if (!canAddToCart()) {
        <p class="text-red-500 text-sm text-center">{{ getValidationMessage() }}</p>
        }
      </div>
    </div>
  </div>
  }
  </div>
  <div class="hidden xl:flex gap-4">
    <!-- Left: image + price -->
    <div class="w-1/4 flex-shrink-0">
      <div class="sticky top-4">
        <div class="flex items-center justify-center mb-4">
         <div class="relative w-full aspect-square">
  <img
    [ngSrc]="product.image || 'assets/images/placeholders/placeholder.webp'"
    [alt]="product.name || 'Image à venir'"
    fill
    loading="lazy"
    sizes="25vw"
    class="rounded-lg object-contain label bg-base-200" />
</div>
          </div>
          <h1 class="text-primary text-2xl font-semibold mb-2">{{product.name}}
  @if (selectedSize) {
  <span class="text-[15px] font-normal text-site">({{selectedSize}})</span>
  }
  </h1>
  <!-- Prix desktop gauche -->
  <div class="mb-2">
    @if (product.pricePerSizes.length === 0) {
  @if (discountReduction && !isRedeemMode) {
  <p
  class="text-sm line-through text-site">{{ formatBasePrice(product.price) }}</p>
                  <p class="text-xl font-bold text-site flex items-center gap-1">
  {{ formatBasePrice(applyReduction(product.price, discountReduction)) }}
  @if (formatReduction(discountReduction)) {
  <span
    class="text-xs bg-[#EB3D08] text-white px-1.5 py-0.5 rounded-full"
  >{{ formatReduction(discountReduction) }}</span>
  }
  </p>
  } @else {
  <p
  class="text-xl font-bold mb-2 text-site">{{ formatBasePrice(product.price) }}</p>
  }
  }
  @if (product.pricePerSizes.length > 0) {
  @if (discountReduction && !isRedeemMode) {
  <p
  class="text-sm line-through text-site">{{ formatBasePrice(selectedPrice) }}</p>
                  <p class="text-xl font-bold text-red-500 flex items-center gap-1">
  {{ applyReduction(selectedPrice, discountReduction) | number:'1.2-2' }} {{ product.currency }}
  @if (formatReduction(discountReduction)) {
  <span
    class="text-xs bg-[#EB3D08] text-white px-1.5 py-0.5 rounded-full"
  >{{ formatReduction(discountReduction) }}</span>
  }
  </p>
  } @else {
  <p
  class="text-xl font-bold mb-2 text-site">{{ formatBasePrice(selectedPrice) }}</p>
  }
  }
  </div>
  <p class="text-site text-sm leading-relaxed">{{product.description}}</p>
          </div>
        </div>
        <!-- Middle: customization -->
        <div class="flex-1 overflow-y-auto pr-4">
          <div class="space-y-6">
            @if (product.ingredients.length > 0) {
  <div class="flex flex-col gap-3">
    <h2 class="title text-secondary text-[24px]">Composition: Décochez si un ingrédient ne vous convient pas 😋🤤</h2>
    <div class="grid 2xl:grid-cols-2 gap-3">
      @for (ingredient of product.ingredients; track ingredient) {
      <label class="ingredient-card bg-base-200 border-border flex items-center justify-between p-3 rounded-lg border"
       [class.cursor-not-allowed]="ingredient.required">

  <div class="flex items-center space-x-3 flex-1 min-w-0">
    <mat-checkbox
      [checked]="selectedIngredients.includes(ingredient.id)"
      [disabled]="ingredient.required"
      (change)="onIngredientChange($event, ingredient.id)">
    </mat-checkbox>

    <div class="flex-1 min-w-0 flex items-center flex-wrap gap-2">
      <span class="text-base text-site font-medium">{{ ingredient.name }}</span>
      @if (ingredient.required) {
      <span class="bg-[#15803D] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] whitespace-nowrap">
          Obligatoire
        </span>
      }
      </div>
    </div>

    @if (ingredient.image) {
      <img [ngSrc]="ingredient.image || 'assets/images/placeholders/placeholder.webp'"
           [alt]="ingredient.name || 'Image à venir'"
           width="60" height="60" loading="lazy"
           class="ingredient-img rounded-lg object-cover">
      }
      </label>
      }
    </div>
  </div>
  }
  @if (product.additions.length >0 && filteredAdditions.length > 0) {
  <h2 class="text-[24px] text-[#FF730A] title mb-0 sticky top-0 z-10"
  >
    Choisissez vos accompagnements 🍗🥦🧀️🥣🥤
  </h2>
  }
  @for (addition of filteredAdditions; track addition; let i = $index) {
  <div class="addition-block"
       [attr.id]="'desktop-component-' + i">
    <h3 class="text-[24px] text-[#FF730A] title mb-3 sticky top-0 z-10">
      {{ getAdditionTitle(addition) }}
      @if (addition.itemsSize) {
      <span class="text-[18px] font-normal text-gray-600"
      >(Taille {{addition.itemsSize.name}})</span>
      }
      <span class="text-[18px] font-normal text-gray-600">
                    ({{ addition.required ? 'Obligatoire' : 'Optionnel' }} - {{ getTotalQuantityForAddition(addition.id) }}
        /{{ addition.quantity }} choix)
                  </span>
    </h3>
    <div class="grid 2xl:grid-cols-2 gap-3">
      @for (item of addition.items; track item) {
      <div
        class=" relative flex items-center justify-between px-[14px] bg-base-200  border cursor-pointer label rounded-[6px]"
        [class.border-orange-500]="getItemQuantity(addition.id, item.id) > 0"
        [class.bg-orange-50]="getItemQuantity(addition.id, item.id) > 0"
        [class.opacity-60]="item.available === false"
        [class.cursor-not-allowed]="item.available === false"
        [class.cursor-pointer]="item.available === true">
        @if (item.available === false) {
      <span
        class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                          Non disponible
                        </span>
      }
      <div class="flex items-center space-x-3 flex-1 min-w-0">
        <div class="flex-1 min-w-0">
          <span class="text-base text-site  font-medium break-words">{{ item.name }}</span>
                          @if (item.price) {
      <span class="text-sm text-site  ml-2">(+{{item.price}} {{item.currency}}
        )</span>
      }
      </div>
    </div>
    <div class="flex items-center gap-2 flex-shrink-0 mr-3">
      <button (click)="decrementItem(addition.id, item.id)"
        [disabled]="getItemQuantity(addition.id, item.id) === 0"
        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
        -
      </button>
      <span class="font-bold min-w-[20px] text-center">{{ getItemQuantity(addition.id, item.id) }}</span>
                        <button [disabled]="item.available === false"
                          (click)="incrementItem(addition.id, item.id, addition.quantity, i)"
                          class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
                          +
                        </button>
                      </div>
                      @if (item.image) {
      <img
        [ngSrc]="item.image || 'assets/images/placeholders/placeholder.webp'"
        [alt]="item.name || 'Image à venir'"
        width="64"
        height="64"
        loading="lazy"
        class="w-16 h-16 rounded-lg flex-shrink-0">
      }
      </div>
      }
    </div>
  </div>
  }
  @if (product.supplements.length > 0) {
  <h2 class="text-[24px] text-[#FF730A] title mb-0 sticky top-0 z-10"
  >Ingrédients Supplémentaires 🍟🧀️🍗</h2>
  }
  @for (category of getSupplementCategories(); track category) {
  <div class="flex flex-col gap-3">
    <h3 class="text-[24px] text-[#FF730A] title mb-3 sticky top-0 z-10">{{ category }}</h3>
    <div class="grid 2xl:grid-cols-2 gap-3">
      @for (supplement of supplementsByCategory[category]; track supplement) {
      <label
        class="flex items-center justify-between px-[14px] bg-base-200  border cursor-pointer label rounded-[6px]"
        [class.border-orange-500]="isSupplementSelected(supplement.id)"
        [class.bg-orange-50]="isSupplementSelected(supplement.id)">
        <div class="flex items-center space-x-3 flex-1 min-w-0">
          <mat-checkbox [checked]="isSupplementSelected(supplement.id)"
          (click)="$event.stopPropagation();toggleSupplement(supplement.id)"></mat-checkbox>
          <div class="flex-1 min-w-0">
            <span class="text-base text-site font-medium break-words">{{ supplement.name }}</span>
                          <span
                            class="text-sm text-site ml-2">(+{{ truncate2(getSupplementPrice(supplement)) | number:'1.2-2' }} {{ supplement.currency }}
      )</span>
    </div>
  </div>
  @if (supplement.image) {

      <img
        [ngSrc]="supplement.image || 'assets/images/placeholders/placeholder.webp'"
        [alt]="supplement.name || 'Image à venir'"
        width="64"
        height="64"
        loading="lazy"
        class="w-16 h-16 rounded-lg flex-shrink-0">
      }
      </label>
      }
    </div>
  </div>
  }
  </div>
</div>
<div class="w-80 flex-shrink-0">
  <div
    class="sticky top-4 bg-base-200 shadow-md flex flex-col gap-2 rounded-[10px] p-[8px] h-[60vh] max-h-[80vh]"
   >
    <div class="flex flex-col h-full  rounded-[6px] overflow-hidden"
     >
      <!-- Header: Nom + Prix -->
      <div class="p-[12px] border-b" style="border-color: var(--border-color);">
        <div class="flex justify-between items-start">
          <div class="flex-1">
            <p class="font-semibold title text-lg text-primary">
  {{ product.name }}
  @if (selectedSize) {
  <span class="text-[15px] font-normal text-dark opacity-60"
  >({{ selectedSize }})</span>
  }
  </p>
</div>
<!-- Prix -->
<div class="text-right">
  @if (discountReduction && !isRedeemMode) {
  <p class="text-xs line-through text-dark opacity-40">
    {{ formatBasePrice(product.pricePerSizes.length === 0 ? product.price : selectedPrice) }}    {{ product.currency }}
  </p>
  <p class="font-bold text-lg flex items-center gap-1 justify-end text-dark">
    {{ formatBasePrice(discountedBasePrice) }}
    @if (formatReduction(discountReduction)) {
    <span class="text-xs bg-[#EB3D08] text-white px-1 py-0.5 rounded-full"
      >
    {{ formatReduction(discountReduction) }}
    </span>
    }
  </p>
  }
  @if (!discountReduction || isRedeemMode) {
  @if (product.pricePerSizes.length === 0) {
  <p class="font-bold text-lg text-dark"
    >
  {{ formatBasePrice(product.price) }}
  </p>
  }
  @if (product.pricePerSizes.length > 0) {
  <p class="font-bold text-lg text-dark"
    >
  {{ formatBasePrice(selectedPrice) }}
  </p>
  }
  }
  </div>
</div>
</div>
<!-- Zone scrollable -->
<div class="flex-1 overflow-y-auto px-[12px] py-4 space-y-6">
<!-- Composition -->
@if (selectedIngredients.length || product.ingredients?.length > 0) {
  <div>
    <span class="text-sm font-semibold block mb-2 text-dark">Composition</span>
    @for (ingredient of product.ingredients; track ingredient) {
    <div class="ml-4">
      <div class="text-sm flex "
     [ngClass]="{
    'opacity-80 text-dark': selectedIngredients.includes(ingredient.id),
    'line-through text-red-500': excludedIngredients.includes(ingredient.id)
    }">
                          <span>- {{ ingredient.name }}</span>
                        </div>
                      </div>
    }
  </div>
  }
  <!-- Additions -->
  @if (hasSelectedAdditions()) {
  <div>
    @for (addition of filteredAdditions; track addition) {
    <div>
      @if (getTotalQuantityForAddition(addition.id) > 0) {
    <span class="text-sm font-semibold block mb-2 text-dark">
                            {{ getAdditionTitle(addition) }}
      @if (addition.itemsSize) {
      <span class="text-sm text-dark opacity-60">
        (Taille {{ addition.itemsSize.name }})
                              </span>
                            }
                          </span>
    @for (item of addition.items; track item) {
    <div class="ml-4">
      @if (getItemQuantity(addition.id, item.id) > 0) {
    <div
      class="text-sm text-dark opacity-70 mb-1">
                                  <span>+ {{ item.name }}
                                    <span class="text-xs opacity-60">x{{ getItemQuantity(addition.id, item.id) }}</span>
                                  </span>
    </div>
    }
    </div>
    }
    }
    </div>
    }
  </div>
  }
  <!-- Suppléments -->
  @if (Object.keys(selectedSupplements).length > 0) {
  <div>
    <span class="text-sm font-semibold block mb-2 text-dark">Suppléments</span>
    @for (supplementId of Object.keys(selectedSupplements); track supplementId) {
    <div class="ml-2">
      @for (supplement of product.supplements; track supplement) {
    @if (supplement.id === supplementId) {
    <div
      class="text-sm text-dark flex justify-between items-center mb-2">
      <span>
        @if (supplement.categories?.length > 0) {
    <span
      class="font-bold text-dark">
                                    {{ supplement.categories[0] }}
                                  </span>
    }
    @if (supplement.categories?.length > 0) {
    <span> - </span>
    }
    {{ supplement.name }}
    <span
      class="text-green-600 font-normal">(+{{ truncate2(getSupplementPrice(supplement)) | number:'1.2-2' }} {{ supplement.currency }}
    )</span>
  </span>
  <mat-icon class="material-symbols-outlined cursor-pointer"
    style="color: red; opacity: 0.7;"
    (click)="toggleSupplement(supplementId)">
    delete
  </mat-icon>
</div>
    }
    }
    </div>
    }
  </div>
  }
  </div>
  <!-- Footer: Quantité + Total -->
  <div class="border-t px-[12px] py-4 space-y-4" style="border-color: var(--border-color);">
    <!-- Quantité -->
    <div class="flex items-center justify-between">
      <span class="font-semibold text-dark">Quantité</span>
      <div class="flex items-center space-x-3">
        <button (click)="decrementProductQuantity()"
          [disabled]="productQuantity <= 1"
          class="w-9 h-9 rounded-full flex items-center justify-center disabled:opacity-50 transition"
          style="border: 2px solid var(--border-color); color: var(--text-site);">
          <span class="text-xl font-bold">-</span>
        </button>
        <span class="font-bold text-xl w-12 text-center text-dark">{{ productQuantity }}</span>
                    <button (click)="incrementProductQuantity()"
                      class="w-9 h-9 rounded-full flex items-center justify-center transition"
                      style="border: 2px solid var(--border-color); color: var(--text-site);">
                      <span class="text-xl font-bold">+</span>
                    </button>
                  </div>
                </div>
                <!-- Total -->
                <div class="flex justify-between items-center text-xl font-bold pt-3 border-t"
                  style="border-color: var(--border-color);">
                  <span class="text-dark">Total</span>
                  <span class="text-dark">
  {{ formatTotal() }}  </span>
</div>
</div>
</div>
<!-- Bouton Ajouter au panier -->
<button (click)="addToCart()"
[matButton]="themeConfig.appearance.button.action"
[disabled]="!canAddToCart() || isSubmitting()"
  class="w-full py-2 "
>
Ajouter au panier
</button>
<!-- Message de validation -->
@if (!canAddToCart()) {
  <p
    class="text-sm mt-2 text-center font-medium text-red-500 opacity-80">
    {{ getValidationMessage() }}
  </p>
  }
  </div>
</div>
</div>
</div>
  }
</div>
